import React from "react";
import { Grid } from "semantic-ui-react";
import { socket } from "../../../../lib/socketio";
import { GroupTemplate } from "../../../Definitions/cl";
import ControlGroupPR from "../../../Monitor/ControlLoops/ControlGroupPR";
import Footer from "../../Footer";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setCurrentPLC, setUserArray } from "../../../../actions/headerActions";
import { setUser } from "../../../../actions/navActions";
import RequestAccessModal from "../../../RequestAccess/RequestAccessModal";
import ConfirmMacro from "../../../Macros/ConfirmMacro";
import TimeColumn from "../../../Monitor/Data/TimeColumn";
import { IO_WRITE, isAuthorized } from "../../../../lib/authorization";

const ParameterReset1_PSM2 = () => {
  const [tags, settags] = React.useState([]);
  const [data, setData] = React.useState([]);

  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const electronApp = useSelector((state) => state.nav.electronApp);
  const [userArr, setUserArr] = React.useState(null);
  const [requestor, setRequestor] = React.useState(null);
  const [pop, setPop] = React.useState(false);
  const dispatch = useDispatch();

  // [UPDATE] LOADTIME OVERRIDE
  const [ovrdata, setOvrdata] = React.useState([]);
  const [tempoverridden, settempoverriden] = React.useState({});
  const [tempovrdata, settempovrdata] = React.useState({});
  const [isCopied, setIsCopied] = React.useState(false);

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  React.useEffect(() => {
    socket.emit("get tag names", [{ display_id: 233 }, { display_id: 128 }]);
    socket.on("receive tag names", (data) => {
      const isFound = data.tags_data.some(
        (element) => element.display_id === 233,
      );
      if (isFound) {
        settags(data.tags_data);
      }
    });

    return () => {
      socket.removeAllListeners();
    };
  }, [tags]);

  const ids = tags.map((t) => t.id);
  const FooterTags = tags.flatMap((t) => (t.display_id === 128 ? [t] : []));
  const GenTags = tags.flatMap((t) => (t.display_id === 233 ? [t] : []));
  const display = GenTags.map((t) => t.page_name);
  const GroupTags = GroupTemplate(GenTags, "tag_display_subgroup");

  React.useEffect(() => {
    if (!electronApp) {
      var currentClient = `${user.name}:${socket.id}:${userCopy.hmi_role}`;
      socket.on("userDict", (response) => {
        let res = response[currentPLC];

        if (res.indexOf(currentClient) === 1) {
          if (userCopy.hmi_role !== user.hmi_role) {
            user.hmi_role = userCopy.hmi_role;
            dispatch(setUser(user));
          }
        } else {
          dispatch(setUserArray(response));

          for (var i = 2; i < res.length; i++) {
            var info = res[i].split(":");
            if (user.name === info[0]) {
              user.hmi_role = "E";
              setUser(user);
            }
          }
        }
      });
      socket.on("permission", (data) => {
        setUserArr(data.mainArr); // local variable
        setRequestor(data.requestor);
        setPop(true);
      });
      socket.on("access granted", (response) => {
        let data = response[currentPLC];
        if (data.indexOf(currentClient) === 1) {
          user.hmi_role = userCopy.hmi_role;
          dispatch(setUser(user));
        } else {
          dispatch(setUserArray(response));
          user.hmi_role = "E";
          dispatch(setUser(user));
        }
      });
      socket.on("access denied", () => {
        alert("ACCESS DENIED");
      });
      socket.on("access transferred", (data) => {
        alert(
          `Access has been tranferred to ${data.requested.split(":")[0]}. Comment: ${data.comment}`,
        );
      });
    }
    if (ids.length > 0) {
      socket.emit("get tag values", ids);
      socket.on("receive tag values", (value) => {
        setData(value.result);
      });

      return () => {
        socket.removeAllListeners();
      };
    }
  }, [ids, data]);

  // [UPDATE] Load Time Override
  const parentcallback = React.useCallback((flag) => {
    if (flag === true) {
      setOvrdata([]);
      setIsCopied(false);
      settags([]);
    }
  }, []);

  GroupTags[0].forEach((el, idx) => {
    if (el[0].tag_display_subgroup === null) {
      let cutOut = GroupTags[0].splice(idx, 1)[0]; // cut the element at index 'from'
      GroupTags[0].splice(0, 0, cutOut);
    }
  });

  GroupTags[0].forEach((el, idx) => {
    if (el.length > 6 && el[0].tag_display_subgroup === null) {
      let idx_n = 0;
      let result = [];

      while (idx_n < el.length) {
        if (idx_n % 6 === 0) {
          result.push([]);
        }
        result[result.length - 1].push(el[idx_n++]);
      }
      GroupTags[0].splice(idx, 1);
      result.forEach((t) => {
        GroupTags[0].unshift(t);
      });
    }
  });

  const prtags = [];
  let rows;
  const length = GroupTags[0].length;
  rows = Math.round(length / 5); //
  let i = 0;
  while (i < length) {
    prtags.push(GroupTags[0].slice(i, i + rows));
    i += rows;
  }

  const filtered = prtags.map(
      subArr => subArr.filter(
          item => item[0].tag_display_subgroup !== 'TIME'
              && item[0].tag_display_subgroup !== 'SHUTDOWN COUNT RESET'
              && item[0].tag_display_subgroup !== 'MWHRSNET'
              && item[0].tag_display_subgroup !== 'FUELTOT'
      )).filter(subArr => subArr.length > 0);

  const handleYes = () => {
    socket.emit("grant access", {
      message: "YES",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };
  const handleNo = () => {
    socket.emit("grant access", {
      message: "NO",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };

  return (
    <div style={styles.div}>
      {!electronApp && pop && (
        <RequestAccessModal
          pop={pop}
          yes={handleYes}
          no={handleNo}
          reqq={requestor.split(":")[0]}
        />
      )}
      <h1 style={styles.header}>{display[0]}</h1>
      <Grid>
        <Grid.Row>
          <Grid.Column
            inverted
            divided
            columns="equal"
            style={styles.grid}
            width={8}
            floated="left"
          >
            <p
              style={{
                marginBottom: "0px",
                fontSize: "21px",
                fontWeight: 450,
                color: "aliceblue",
              }}
            >
              PARAMETERS
            </p>
            {prtags.map((c, i) => (
              <TimeColumn
                key={i}
                index={i}
                column={c}
                data={data}
                title={"LOAD/RATED TIME"}
                ovrdata={ovrdata}
                tags={tags}
                settags={settags}
                tempovrdata={tempovrdata}
                settempovrdata={settempovrdata}
                tempoverridden={tempoverridden}
                settempoverriden={settempoverriden}
                isCopied={isCopied}
                setIsCopied={setIsCopied}
                parentCallback={parentcallback}
              />
            ))}
          </Grid.Column>
          <Grid.Column
            columns="equal"
            style={styles.grid}
            width={8}
            floated="right"
          >
            <p
              style={{
                marginBottom: "20px",
                fontSize: "21px",
                fontWeight: 450,
                color: "aliceblue",
              }}
            >
              S/D COUNT RESET
            </p>
            {(electronApp || isAuthorized(user.hmi_role, IO_WRITE)) && (
              <div style={{ display: "flex", gap: "10px" }}>
                <ConfirmMacro option={2} channel={"PSM2 ESTOP CNT RESET"} />
                <ConfirmMacro option={2} channel={"PSM2 FUELLED CNT RESET"} />
                <ConfirmMacro option={2} channel={"PSM2 UNFUELLED CNT RESET"} />
              </div>
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <Grid inverted divided centered columns="equal" style={styles.grid}>
        <Grid.Column style={{ maxWidth: "2000px" }}>
          <Grid inverted divided centered columns="equal" style={styles.grid}>
            {filtered.map((c, i) => (
              <ControlGroupPR index={i} column={c} data={data} />
            ))}
          </Grid>
        </Grid.Column>
      </Grid>
      <Footer tags={FooterTags} data={data} />
    </div>
  );
};
const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  toggle: {
    marginLeft: "8px",
  },
  grid: {
    marginTop: "2px",
  },
};

export default ParameterReset1_PSM2;
